import apiClient from './index'
import type { Loan, LoanCreate, LoanUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/loans'

export const loansApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<Loan[]>(BASE_URL, { params }).then(res => res.data),
  getById: (id: number) => apiClient.get<Loan>(`${BASE_URL}/${id}`).then(res => res.data),
  create: (data: LoanCreate) => apiClient.post<Loan>(BASE_URL, data).then(res => res.data),
  update: (id: number, data: LoanUpdate) => apiClient.put<Loan>(`${BASE_URL}/${id}`, data).then(res => res.data),
  delete: (id: number) => apiClient.delete<Loan>(`${BASE_URL}/${id}`).then(res => res.data),
}
